<template>
  <div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Shop kết nối
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <span style="font-weight: 700">1 shop</span>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Care Ads tự động
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Quản lý từ khóa
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Bảo hiểm rủi ro
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Tuần xuất hoạt động
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <span style="color: red; font-weight: 600">
          <template v-if="pack.extra_data.mode === 'eco'">Ổn định</template>
          <template v-if="pack.extra_data.mode === 'ultra'">Nhanh</template>
        </span>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 55%; padding-right: 10px; font-weight: 600;">
        Chi phí vận hành
      </div>
      <div style="display: inline-block; width: 43%; text-align: right">
        <span style="color: red; font-weight: 600">
          {{ pack.extra_data.cost * 100 }}% doanh thu<br>chiến dịch / ngày
        </span>
      </div>
    </div>
    <div style="height: 80px"></div>
  </div>
</template>

<script>
export default {
  props: {
    pack: {
      type: Object,
      required: true
    }
  },

  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/pages/package/component/atosa_agent_component.vue